import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import { useEffect, useRef, useState } from "react";
import "./OtpDialog.css";
import { t } from "i18next";
import { ekycTransfer, sendOtpEkyc, verifyOtpEkyc } from "../../Services/api-service";
import { hidePhoneNumber, isNullOrEmpty } from "../../Services/service";
import { error, success } from "../../Components/custom-toast/CustomToast";

function OtpPhoneDialogWidget({ objectDto, setObjectDto, setLoading }) {
  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);
  document.body.style.overflow = "hidden";
  const handleExit = () => {
    setObjectDto(prev => ({...prev, sendVerifyPhone: 0}));
    localStorage.removeItem("####");
  };

  const handleSubmit = (otp) => {
    var temp = {...objectDto, phoneOtp: otp};
    setLoading(true);
    verifyOtpEkyc(temp).then((value)=>{
      if(value === true) {
        success(t("verifysuccess"));
        const db = {idnumber: objectDto.idnumber, dob: objectDto.dob, iddate: objectDto.iddate, applicationNo: objectDto.applicationNo, fullName: objectDto.fullName};
        ekycTransfer(db).then((data)=> {
          if(!data) {
            document.body.style.overflow = "auto";
            setObjectDto(prev => ({...prev, sendVerifyPhone: 0}));
            return;
          }
        });
      }else if(value === false){
        document.body.style.overflow = "hidden";
        setOtp(new Array(length).fill(""));
        inputRefs?.current?.[0]?.focus();
      }else{
        // error("Lỗi hệ thống, vui lòng thử lại sau");
        document.body.style.overflow = "auto";
        setObjectDto(prev => ({...prev, sendVerifyPhone: 0}));
        localStorage.removeItem("####");
      }
    }).finally(()=>{
      setLoading(false);
    });
  };
  const handleResendOtp = () => {
    setLoading(true);
    sendOtpEkyc(objectDto, setObjectDto, setLoading).then(data => {
      if(data === true){
        setTimeLeft(objectDto.expiredPhoneOtp*60);
        setOtp(new Array(length).fill(""));
        setWrong(false);
        localStorage.setItem("####", objectDto.expiredPhoneOtp*60);
        inputRefs?.current?.[0]?.focus();
        document.body.style.overflow = "hidden";
      }else if(data === false){
        document.body.style.overflow = "auto";
        setObjectDto(prev => ({...prev, sendVerifyPhone: 0}));
        localStorage.removeItem("####");
      }else{
        error("Lỗi hệ thống, gửi sms không thành công");
        document.body.style.overflow = "auto";
        setObjectDto(prev => ({...prev, sendVerifyPhone: 0}));
        localStorage.removeItem("####");
      }
    });
  };

  const handleChange = async (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    const combinedOtp = newOtp.join("");

    if (combinedOtp.length === length) {
      return handleSubmit(combinedOtp);
    }
    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleClick = (index) => {
    inputRefs.current[index].setSelectionRange(1, 1);
    if (index > 0 && !otp[index - 1]) {
      inputRefs.current[otp.indexOf("")].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1].focus();
    }
  };

  const [timeLeft, setTimeLeft] = useState(objectDto.expiredPhoneOtp*60);
  useEffect(()=>{
    if(isNullOrEmpty(localStorage.getItem("####"))){
      localStorage.setItem("####", objectDto.expiredPhoneOtp*60);
    }else{
      setTimeLeft(localStorage.getItem("####"))
    }
  },[])

  useEffect(() => {
    if (timeLeft === 0) {
      localStorage.removeItem("####");
      setWrong(true);
      return;
    }
    localStorage.setItem("####", timeLeft);
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes < 10 ? "0" : ""}${minutes}:${
    seconds < 10 ? "0" : ""
  }${seconds}`;
  const [wrong, setWrong] = useState(false);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs?.current?.[0]?.focus();
    }
  }, []);
  return (
    <>
    <div className="otp-dialog-overlay">
      <div className="otp-dialog">
        <h2>{t("verifyotpphone")}</h2>
        <p className="desc-otp">
          {
            objectDto.vendorType === 1 ? (<>{t("verifyotpphonenewest1")}</>) : (<>{t("verifyotpphonenewest2")}</>)
          }
          
          <strong style={{ color: "#007AFF" }}>{hidePhoneNumber(objectDto.phoneNumber)}</strong>
          {t("verifyotpphone2")}
          {!wrong ? (
            <>{t("verifyotpphone3") + formattedTime + t("minute")}</>
          ) : (
            <p style={{ color: "red" }}>{t("otpexpired")}</p>
          )}
        </p>

        <div className="otp-actions">
          <div className="otp-input-container">
          {
            !wrong ?
              <div className="otp-input-label">
                {
                  otp.map((value, index) => {
                    return (
                      <input
                        key={index}
                        inputMode="numeric"
                        type="text"
                        ref={(input) => (inputRefs.current[index] = input)}
                        value={value}
                        onChange={(e) => handleChange(index, e)}
                        onClick={() => handleClick(index)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        className="otp-input"
                      />
                    );
                  })
                }
                </div>
              : <></>
            }
            <div className="otp-input-button">
              <CustomButtonColor
                size={"large"}
                title={"Thoát"}
                color={"#fff"}
                borderRadius={"5px"}
                bgColor={"#c59812"}
                onClick={handleExit}
              />
              <CustomButtonColor
                size={"large"}
                title={wrong ? t("resendOtp") : t("confirmOtp")}
                color={"#fff"}
                borderRadius={"5px"}
                bgColor={"#c59812"}
                onClick={wrong ? ()=>handleResendOtp() : ()=>
                  {
                    const newOtp = [...otp];
                    const combinedOtp = newOtp.join("");
                    handleSubmit(combinedOtp);
                  }
              }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
export default OtpPhoneDialogWidget;
